interface ToolkitEmptyStateProps {
  hasSearchQuery: boolean;
}

export const ToolkitEmptyState = ({ hasSearchQuery }: ToolkitEmptyStateProps) => {
  if (hasSearchQuery) {
    return (
      <div className="mx-2 flex h-48 items-center justify-center">
        <div className="flex flex-col items-center gap-3 rounded-2xl px-6 py-5 text-center">
          <div className="text-theme-text-grey flex h-10 w-10 items-center justify-center rounded-full">
            <i className="pi pi-search text-sm" />
          </div>
          <div className="space-y-1">
            <p className="text-theme-black text-sm font-medium">No tools match your search</p>
            <p className="text-theme-text-grey text-sm">
              Try a different keyword or clear the search field to see all available tools.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-32 items-center justify-center">
      <div className="text-theme-text-grey">No tools found</div>
    </div>
  );
};
